// Engine identity, carried by every result (docs/ENGINE-GUIDE.md). GPL-3.0-or-later.
export const ENGINE = { name: "@dipfield/rock", version: "0.2.0" } as const;
